'use strict';
import customModal from '../modal';
import validator  from '../validator';
import util  from '../util';

//function to open accordion by default on one layout only
function updateSummaryAccordion() {
    //For Cart,Shipping,Billing page promo code form 
    $('.cart-coupon-code').on('keydown', 'input', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('#add-coupon').trigger('click');
        }
    });

    const $checkoutAccordion = $('.checkout-products-accordion');
    const $orderHelpContainer = $('.order-help-container');

    if ($('.reviewstepclass').length > 0) {
        $checkoutAccordion.find('.accordion_title').addClass('open');
        $checkoutAccordion.find('.accordion_description').show();
    }

    if ($('.pt_cart').length > 0 && window.innerWidth > 768 && $orderHelpContainer.length > 0) {
        $orderHelpContainer.find('h3').addClass('open');
        $orderHelpContainer.find('.accordion_description').show();
    } else {
        $orderHelpContainer.find('h3').removeClass('open');
        $orderHelpContainer.find('.accordion_description').hide();
    }
}

//Place order button sticky
function stickyPlaceOrder() {
    $(window).on('scroll', util.debounce(handleScroll, 100));
}

function handleScroll() {
    let stickyOrderInitialized = false;
    const $orderSummaryFooter = $('.order-summary-footer');
    const $orderSummaryCheckout = $orderSummaryFooter.find('.place-order-checkout');
    if (($(window).width() < 769) && $orderSummaryFooter.length > 0) {
        if ($('.checkout-step.review .place-order-button').isInViewport()) {
            if ($orderSummaryCheckout.length > 0) {
                $orderSummaryCheckout.removeClass('show');
            }
        } else {
            if ($orderSummaryCheckout.length > 0) {
                $orderSummaryCheckout.addClass('show');
            }
            if (!stickyOrderInitialized) {
                stickySubmitOrder();
                stickyOrderInitialized = true;
            }
        }
    }
}

const stickySubmitOrder = function () {
    const $stickyPlaceOrder = $('#sticky-place-order');
    const $orderSummaryFooter = $('.order-summary-footer');
    const $orderSummaryForm = $('.order-summary-footer').find('form');
    $stickyPlaceOrder.attr('disabled', document.getElementById('summary-place-order').disabled);
    $orderSummaryFooter.on('change', 'input[data-id="input-userconsent-termsandconditions"]', util.debounce(function () {
        if (!$orderSummaryForm.valid()) {
            $stickyPlaceOrder.prop('disabled', true);
        } else {
            $stickyPlaceOrder.prop('disabled', false);
        }
    }, 300));
    $orderSummaryFooter.on('click', $stickyPlaceOrder, util.debounce(function (e) {
        $stickyPlaceOrder.trigger('click');
        if (!$orderSummaryForm.valid()) {
            $stickyPlaceOrder.prop('disabled', true);
        } else {
            $stickyPlaceOrder.prop('disabled', false);
        }
    }, 300));
}

function submitNationalityData() {
    let $nationalityForm = $('#dwfrm_singleshipping_shippingAddress');
    $.ajax({
        type: 'POST',
        url: $nationalityForm.attr('action'),
        data: $nationalityForm.serialize() + '&dwfrm_singleshipping_shippingAddress_save=dwfrm_singleshipping_shippingAddress_save'
    }).always(function (data) {
        $('#summary-form')[0].submit();
    });

}

// renders the nationality popup
function getPaypalPayDisplayNationality() {
    customModal.createCustomModal('apple-pay-nationality-popup', '#modal-custom-placeholder');
    $.ajax({
        type: 'GET',
        url: Urls.applePayGetNationality,
        data: {},
        success: function (response) {
            $('.apple-pay-nationality-popup').find('.modal-body').html(response);
        },
        error: function () {
            alert('something went wrong');
        }
    }).always(function (data) {
        $('select[id$="_nationalIDType"]').selectmenu();
        validator.initForm('form[id="dwfrm_singleshipping_shippingAddress"]');

        $('.account-settings-wrap').on('blur', 'select[id$="_nationalIDType"] + .ui-selectmenu-button', function () {
            validator.initDocIdValidation();
        });

        $('#modal-custom-placeholder').on('click', '#dwfrm_singleshipping_shippingAddress_save', function (e) {
            e.preventDefault();
            submitNationalityData();
        });
    });
}

function initializeNationalityPopin() {
    $('#summary-place-order').on('click', function (e) {

        if ($('.order-summary-footer form').valid() && $(this).data('displaynationalitypopin') == true) {
            e.preventDefault();
            getPaypalPayDisplayNationality();
        }
    });
}

// Checkout Newsletter Optin Consent

function initializeOptinContainer() {
    const $checkoutMainWrapper = $('.checkout-main-wrapper');
    if ($checkoutMainWrapper.find('.hide-btn-container').length) {
        $checkoutMainWrapper('.show-content-wrapper').remove();
    }

    // Cache the parent container and its children elements
    const $parentContainer = $('.checkout-newsletter-optin');
    const $secondaryText = $parentContainer.find('.secondary-text');
    const $primaryText = $parentContainer.find('.primary-text');
    const $seeMoreConsent = $parentContainer.find('.see-more-consent');
    const $seeLessConsent = $parentContainer.find('.see-less-consent');

    // Checkbox toggle to show contnet
    $parentContainer.on('click', 'input[type="checkbox"]', function () {
        const showContentWrapper = $('.checkout-main-wrapper').find('.show-content-wrapper');
        const windowWidth = $(window).width();
        const isDesktop = windowWidth > 480;
        const isChecked = $(this).prop('checked');

        // for desktop
        if (isDesktop) {
            $seeMoreConsent.removeClass('is-active');
            $seeLessConsent.removeClass('is-active');
        }

        if (isDesktop) {
            $secondaryText.toggleClass('is-active', isChecked);
        }

        // for mobile
        if (!isDesktop && isChecked && !$(showContentWrapper).length) {
            $secondaryText.addClass('is-active');

        } else if (!isDesktop && !isChecked && !$(showContentWrapper).length) {
            $secondaryText.removeClass('is-active');
        }

        // for mobile & Show btn
        if (!isDesktop && isChecked && $(showContentWrapper).length) {
            $primaryText.addClass('show-text');
            $seeMoreConsent.addClass('is-active');

        } else if (!isDesktop && !isChecked && $(showContentWrapper).length) {
            $primaryText.removeClass('show-text');
            $seeMoreConsent.removeClass('is-active');

            if (!$seeMoreConsent.hasClass('is-active')) {
                $secondaryText.removeClass('is-active');
                $seeLessConsent.removeClass('is-active');
            }
        }
    });

    // Show more content
    $parentContainer.on('click', '.see-more-consent', function () {
        $(this).toggleClass('is-active');
        $secondaryText.toggleClass('is-active');
        $seeLessConsent.toggleClass('is-active');
    });

    // Show less content
    $parentContainer.on('click', '.see-less-consent', function () {
        $(this).toggleClass('is-active');
        $secondaryText.toggleClass('is-active');
        $seeMoreConsent.toggleClass('is-active');
    });
}

export default {
    init : function () {
        updateSummaryAccordion();

        if ($('.checkout-step.shipping').length) {
            stickyPlaceOrder();
            initializeNationalityPopin();
            initializeOptinContainer();
        }
        function handleResize() {
            const $cartRightColumn = $('.cart-right-column');
            const $billing = $('#primary .billing');
            const $secondaryCheckout = $('#secondary .right-side-checkout');
            if ($cartRightColumn && $cartRightColumn.length > 0) {
                updateSummaryAccordion();
            }

            if ($(window).width() > 991 && $secondaryCheckout.length && $('.checkout_page').length) {
                var checkoutStickySidebar = new StickySidebar('#secondary .right-side-checkout', {
                    topSpacing: $billing.length ? -180 : 0,
                    bottomSpacing: $billing.length ? 10 : 10,
                    resizeSensor: true,
                    innerWrapperSelector: '.sidebar__inner'
                });
            }
        }
        $(window).on('resize', util.debounce(handleResize, 200));
    }
};
